export enum SubAssetTypeIds {
  equipment = 'equipment',
  component = 'component',
}

// ! This asset types should be fetched from the backend when available
export enum AssetTypeIds {
  equipment = SubAssetTypeIds.equipment,
  site = 'site',
  well = 'well',
  pipeline = 'pipeline',
  component = SubAssetTypeIds.component,
  unattributed = 'unattributed',
  facility = 'facility',
}

export const ASSET_TYPE_ID_ORDER = [
  AssetTypeIds.site,
  AssetTypeIds.equipment,
  AssetTypeIds.well,
  AssetTypeIds.pipeline,
  AssetTypeIds.facility,
]

export const NO_NAME_PLACEHOLDER = 'Unknown Name'

export const ASSET_COORDINATE_PROPERTIES = [
  'centroidLatitude',
  'centroidLongitude',
]
